var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.217,
    height: 19.467,
    viewBox: "0 0 27.217 36.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8301",
    "data-name": "Group 8301",
    transform: "translate(16156.168 19319.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16060",
    "data-name": "Path 16060",
    d: "M468.5,0a13.748,13.748,0,0,1,14.066,13.453,15.515,15.515,0,0,1-2.25,7.385,90.153,90.153,0,0,1-7.913,11.7c-.812,1.084-1.6,2.185-2.422,3.262-.664.87-1.432.9-2.06.025-3.078-4.29-6.2-8.55-9.164-12.919a17.992,17.992,0,0,1-3.29-7.8c-.626-5.08,1.293-9.178,5.254-12.323A12.858,12.858,0,0,1,468.5,0m.345,19.919a6.29,6.29,0,1,0-6.2-6.4,6.29,6.29,0,0,0,6.2,6.4",
    transform: "translate(-16611.518 -19319)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16061",
    "data-name": "Path 16061",
    d: "M480.769,31.917a6.29,6.29,0,1,1,6.384-6.215,6.291,6.291,0,0,1-6.384,6.215",
    transform: "translate(-16623.443 -19330.998)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.4c334e3ec7f4f52440db3307c7a4b514.svg";
export { ForwardRef as ReactComponent };